import { render } from "./SideBarNavigation.vue?vue&type=template&id=bf84c4ca&scoped=true"
import script from "./SideBarNavigation.vue?vue&type=script&lang=js"
export * from "./SideBarNavigation.vue?vue&type=script&lang=js"

import "./SideBarNavigation.vue?vue&type=style&index=0&id=bf84c4ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf84c4ca"]])

export default __exports__